import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";
import ShareButton from "Components/ShareButton";
import { useDevice } from "common/hooks/useDevice";

const SwipeOverlayArticleSharing = () => {
  const { screenSize } = useDevice();

  return (
    <Wrapper>
      <Title>SPREAD THE NEWS</Title>
      <ButtonWrapper>
        <ShareButton type="email" url="" />
        <ShareButton type="twitter" url="" />
        <ShareButton type="facebook" url="" />

        {screenSize.medium && <ShareButton type="whatsApp" url="" />}
      </ButtonWrapper>
    </Wrapper>
  );
};

export default SwipeOverlayArticleSharing;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  @media (max-width: ${defaultBreakpoints.medium}) {
  }
`;

export const Title = styled.span`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 12px;
  font-weight: 800;
  @media (max-width: ${defaultBreakpoints.medium}) {
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: ${defaultBreakpoints.medium}) {
    //min-width: 250px;
  }
`;
